import Component from './InDmHeader.vue'
export default Component
export * from './types'
